import { render } from "./Username.vue?vue&type=template&id=b34cb13c&scoped=true"
import script from "./Username.vue?vue&type=script&lang=js"
export * from "./Username.vue?vue&type=script&lang=js"

import "./Username.vue?vue&type=style&index=0&id=b34cb13c&scoped=true&lang=css"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34cb13c"]])

export default __exports__